module.exports = __webpack_public_path__ + "media/application/images/icons/info-ecb16bdbbe2ae98c58c832c769ed73e8.svg";